import { PRODUCTS_NAMES, TYPES_PLANS } from "#/constants";
import { HOME_PREVIOUS, MY_PLAN_PREVIOUS } from "./previous";
import { BreadcrumbPropsWithPlan, BreadcrumbPropsBase } from "../types";
import {
  CONTRACT_CHILDRENS_BREADCRUMP,
  MY_PLAN_CHILDRENS_BREADCRUMP,
  DEPENDENTS_CHILDRENS_BREADCRUMP,
  NEW_DEPENDENTS_CHILDRENS_BREADCRUMP,
} from "./utils";

export const PLANS_BREADCRUMP: BreadcrumbPropsBase = {
  previousPages: [HOME_PREVIOUS],
  pageName: "Meu Plano",
};

export const MY_PLAN_BREADCRUMP: BreadcrumbPropsWithPlan = (typePlan) => ({
  previousPages: [HOME_PREVIOUS, MY_PLAN_PREVIOUS()],
  pageName: `Meu Plano ${PRODUCTS_NAMES[typePlan as TYPES_PLANS]}`,
});

export const CONTACT_BREADCRUMP: BreadcrumbPropsWithPlan = (typePlan) =>
  MY_PLAN_CHILDRENS_BREADCRUMP(typePlan, "Contatos");

export const PAYMENT_BREADCRUMP: BreadcrumbPropsWithPlan = (typePlan) =>
  MY_PLAN_CHILDRENS_BREADCRUMP(typePlan, "Pagamentos");

export const CONTRACT_BREADCRUMP: BreadcrumbPropsWithPlan = (typePlan) =>
  MY_PLAN_CHILDRENS_BREADCRUMP(typePlan, "Dados do contrato");

export const DETAILS_PLAN_BREADCRUMP: BreadcrumbPropsWithPlan = (typePlan) =>
  CONTRACT_CHILDRENS_BREADCRUMP(typePlan, "Detalhes do plano");

export const COMPLEMENTARY_DATA_BREADCRUMP: BreadcrumbPropsWithPlan = (
  typePlan
) => CONTRACT_CHILDRENS_BREADCRUMP(typePlan, "Dados complementares");

export const DEPENDENTS_BREADCRUMP: BreadcrumbPropsWithPlan = (typePlan) =>
  MY_PLAN_CHILDRENS_BREADCRUMP(typePlan, "Dependentes");

export const NEW_DEPENDENTS_BREADCRUMP: BreadcrumbPropsWithPlan = (
  typePlan
) => ({
  ...DEPENDENTS_CHILDRENS_BREADCRUMP(typePlan, "Novo Dependente"),
  confirmationToQuit: {
    title: "Deseja cancelar adição de dependente?",
    text: "Ao voltar sem salvar, você perderá as informações dos dependente pré-cadastrado.",
  },
});

export const ADD_DEPENDENT_BREADCRUMP: BreadcrumbPropsBase =
  NEW_DEPENDENTS_CHILDRENS_BREADCRUMP("Adicionar Dependente");
